import { motion } from 'framer-motion';

const IntegrationSection = () => {
  return (
    <section id="integration" className="py-24 px-6 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <motion.div
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="inline-flex items-center space-x-2 bg-[#1A2B4A] text-white px-6 py-3 rounded-full text-lg font-bold mb-12 shadow-xl"
          >
            <i className="ri-flashlight-line text-2xl"></i>
            <span>Şu An İçin ManageEngine ServiceDesk Plus'a Özel!</span>
          </motion.div>

          <div className="flex items-center justify-center space-x-8 mb-12">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="bg-white p-6 rounded-2xl shadow-lg w-48 h-32 flex items-center justify-center"
            >
              <img 
                src="https://static.readdy.ai/image/9c916c921dab6b7efa0ebb131a6ff24b/745abf2060d327600b7ab257b8575c0f.webp"
                alt="ManageEngine Logo"
                className="w-full h-full object-contain object-center grayscale hover:grayscale-0 transition-all"
              />
            </motion.div>

            <motion.div
              animate={{ x: [0, 10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="flex items-center space-x-2"
            >
              <i className="ri-arrow-left-right-line text-4xl text-[#FF6B35]"></i>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="bg-white p-6 rounded-2xl shadow-lg w-48 h-32 flex items-center justify-center"
            >
              <img 
                src="https://public.readdy.ai/ai/img_res/c7ca1cd9-942c-41a6-a724-9a8ab077dd81.png"
                alt="Zimmetle.com Logo"
                className="w-full h-full object-contain object-center"
              />
            </motion.div>
          </div>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
            className="text-xl text-gray-700 max-w-3xl mx-auto mb-8 leading-relaxed"
          >
            Mevcut ITSM akışınızı bozmadan, ServiceDesk Plus üzerine bir <strong className="text-[#1A2B4A]">'add-on'</strong> olarak eklenir. Kurulumu sadece <strong className="text-[#FF6B35]">birkaç dakika</strong> sürer.
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.7 }}
            className="inline-flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-[#FF6B35]/10 to-[#1A2B4A]/10 rounded-full border border-[#FF6B35]/30"
          >
            <i className="ri-time-line text-[#FF6B35] text-xl"></i>
            <span className="text-[#1A2B4A] font-semibold">5 Dakikada Kurulum Tamamlanır</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default IntegrationSection;
